import { render, staticRenderFns } from "./FooterGnb.vue?vue&type=template&id=70e31b69&scoped=true"
import script from "./FooterGnb.vue?vue&type=script&lang=js"
export * from "./FooterGnb.vue?vue&type=script&lang=js"
import style0 from "./FooterGnb.vue?vue&type=style&index=0&id=70e31b69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e31b69",
  null
  
)

export default component.exports